// extracted by mini-css-extract-plugin
export default {"Pager":"Pager_Pager__jCiPc"};